var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto;\n    color: ", ";\n"], ["\n    margin: auto;\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorControlIcon;
});
export var NextIcon = function () { return (React.createElement(StyledSvg, { viewBox: "0 0 11 7", width: "11px", height: "7px" },
    React.createElement("polygon", { fill: "currentColor", points: "7 7 11 3.5 7 0 7 3 0 3 0 4 7 4 7 7" }))); };
var templateObject_1;
//# sourceMappingURL=NextIcon.js.map